import React, { useEffect, useState } from "react";

import * as styles from "../../../../../styles/WholedataPage";

import axios from "axios";
import { diaryItemtype } from "../../../../../reducer/postpayloadtypes";

const Growing = ({ OpenWork, growing, setGrowing, inputitem }: any) => {
  const diaryitemid: any = [];
  inputitem &&
    inputitem.map((item: any, idx: any) => {
      if (item.view === "Y") {
        diaryitemid.push(item.diaryItemId);
      }
    });

  const InputHandler = (e: any) => {
    let value = e.target.value;

    setGrowing({
      ...growing,
      [e.target.name]: {
        diaryItemId: e.target.dataset.id,
        value: value,
      },
    });
  };

  return (
    <styles.WorkItemBox className={OpenWork === false ? "hide" : ""}>
      {inputitem &&
        inputitem.map((item: any, idx: Number) => {
          if (item.view === "Y") {
            return (
              <styles.WorkItem>
                <div className="work-item-top">
                  <p className="work-item-title">{item?.note}</p>
                  <p className="work-item-unit">{item?.unit}</p>
                </div>
                <input
                  type="text"
                  data-Id={item.diaryItemId}
                  name={item.name}
                  onChange={InputHandler}
                />
              </styles.WorkItem>
            );
          }
        })}
    </styles.WorkItemBox>
  );
};

const FeedChange = ({
  OpenWork,
  inputitem,
  feedchange,
  setFeedchange,
}: any) => {
  const InputHandler = (e: any) => {
    setFeedchange({
      ...feedchange,
      [e.target.name]: {
        diaryItemId: e.target.dataset.id,
        value: e.target.value,
      },
    });
  };
  return (
    <styles.WorkItemBox className={OpenWork === false ? "hide" : ""}>
      {inputitem &&
        inputitem.map((item: any, idx: Number) => {
          if (
            item.view === "Y" &&
            item.name !== "totalSoilWeight" &&
            item.view === "Y" &&
            item.name !== "totalFeedWeight"
          ) {
            return (
              <styles.WorkItem>
                <div className="work-item-top">
                  <p className="work-item-title">{item.note}</p>
                  <p className="work-item-unit">{item.unit}</p>
                </div>
                <input
                  type="text"
                  data-Id={item.diaryItemId}
                  name={item.name}
                  onChange={InputHandler}
                />
              </styles.WorkItem>
            );
          }
        })}
    </styles.WorkItemBox>
  );
};

const Cleaning = ({ OpenWork, inputitem, cleaning, setCleaning }: any) => {
  let [ischecked, setIschecked] = useState<any>(false);

  const InputHandler = (e: any) => {
    console.log("e.target.checked:", e.target.checked);
    if (e.target.name === "moveBox" && e.target.checked === true) {
      setIschecked(true);
    } else {
      setIschecked(false);
    }
    setCleaning({
      ...cleaning,
      [e.target.name]: {
        diaryItemId: e.target.dataset.id,
        value:
          e.target.checked === null && undefined ? false : e.target.checked,
      },
    });
  };

  const cleanitemid: diaryItemtype = inputitem.find(
    (v: diaryItemtype) => v.name == "cleanDate"
  );
  return (
    <styles.WorkItemBox className={OpenWork === false ? "hide" : ""}>
      <styles.CleaningCheckBox>
        <label>
          <input
            id="cleanDate"
            value=""
            type="checkbox"
            data-Id={cleanitemid.diaryItemId}
            name="cleanDate"
            onChange={InputHandler}
          />
          청소
        </label>
      </styles.CleaningCheckBox>
    </styles.WorkItemBox>
  );
};

const FeedGive = ({ OpenWork, inputitem, feedGive, setFeedGive }: any) => {
  let [feed, setFeed] = useState<any>();
  let [ischecked, setIschecked] = useState<any>(false);

  const InputHandler = (e: any) => {
    setFeedGive({
      ...feedGive,
      [e.target.name]: {
        diaryItemId: e.target.dataset.id,
        value: e.target.value,
      },
    });
  };

  const InpuchecktHandler = (e: any) => {
    if (e.target.name === "feedTime" && e.target.checked === true) {
      setIschecked(true);
    } else {
      setIschecked(false);
    }

    if (e.target.name === "lastfeedTime" && e.target.checked === true) {
      setIschecked(true);
    } else {
      setIschecked(false);
    }

    setFeedGive({
      ...feedGive,
      [e.target.name]: {
        diaryItemId: e.target.dataset.id,
        value:
          e.target.checked === null && undefined ? false : e.target.checked,
      },
    });
  };
  
  useEffect(() => {
    axios.get(`ifactory/api/feed?farmId=${localStorage.getItem("targetfarm")}`)
      .then((res) => {
        console.log("feed :: ", res.data);
        setFeed(res.data);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }, []);

  console.log("1");
  useEffect(() => {
    let feedName = inputitem?.filter((v: any) => v.name === "feedName");

    setFeedGive({
      ...feedGive,
      feedTime: { diaryItemId: null, value: null },
      lastfeedTime: { diaryItemId: null, value: null },

      feedName: {
        diaryItemId: feedName[0]?.diaryItemId,
        value: feed?.[0]?.feedName,
      },
      feedWeight: { diaryItemId: null, value: null },
      boxFeedWeight: { diaryItemId: null, value: null },
      boxWeight: { diaryItemId: null, value: null },
    });
  }, [feed]);

  return (
    <styles.WorkItemBox className={OpenWork === false ? "hide" : ""}>
      {inputitem &&
        inputitem.map((item: any, idx: Number) => {
          if (
            item.view === "Y" &&
            item.name !== "expAmount" &&
            item.view === "Y" &&
            item.name !== "feedTotalCount"
          ) {
            if (item.name === "feedTime") {
              return (
                <styles.WorkItem>
                  <styles.CleaningCheckBox style={{}}>
                    <label
                      style={{
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                      }}
                    >
                      <input
                        id="feedTime"
                        value=""
                        type="checkbox"
                        data-Id={item.diaryItemId}
                        name="feedTime"
                        onChange={InpuchecktHandler}
                      />
                      {item.note}
                    </label>
                  </styles.CleaningCheckBox>
                </styles.WorkItem>
              );
            } else if (item.name === "lastfeedTime") {
              return (
                <styles.WorkItem>
                  <styles.CleaningCheckBox style={{}}>
                    <label
                      style={{
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                      }}
                    >
                      <input
                        id="lastfeedTime"
                        value=""
                        type="checkbox"
                        data-Id={item.diaryItemId}
                        name="lastfeedTime"
                        onChange={InpuchecktHandler}
                      />
                      {item.note}
                    </label>
                  </styles.CleaningCheckBox>
                </styles.WorkItem>
              );
            } else if (item.name === "feedName") {
              return (
                <styles.WorkItem>
                  <div className="work-item-top">
                    <p className="work-item-title">{item.note}</p>
                    <p className="work-item-unit">{item.unit}</p>
                  </div>
                  <select
                    name={item.name}
                    data-Id={item.diaryItemId}
                    onChange={InputHandler}
                  >
                    {feed &&
                      feed.map((feed: any) => {
                        return (
                          <option value={feed.feedName}>{feed.feedName}</option>
                        );
                      })}
                  </select>
                </styles.WorkItem>
              );
            } else {
              return (
                <styles.WorkItem>
                  <div className="work-item-top">
                    <p className="work-item-title">{item.note}</p>
                    {/* <p className="work-item-unit">(개체)</p> */}
                    <p className="work-item-unit">{item?.unit}</p>
                  </div>
                  <input
                    type="text"
                    data-Id={item.diaryItemId}
                    name={item.name}
                    onChange={InputHandler}
                  />
                </styles.WorkItem>
              );
            }
          }
        })}
    </styles.WorkItemBox>
  );
};

const Disease = ({
  OpenWork,
  inputitem,
  disease,
  setDisease,
  occurImage,
  deathImage,
  setDeathImage,
  setOccurImage,
}: any) => {
  const [occurViewImage, setOccurViewImage] = useState<any>([]);
  const [deathViewImage, setDeathViewImage] = useState<any>([]);

  const DiseaseImageController = (Image: any) => {
    if (Image.target.id === "Occur") {
      setOccurImage([...occurImage, Image.target.files[0]]);
      if (occurViewImage.length >= 10) {
        alert("이미지는 최대 10장까지 등록 가능합니다.");
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          setOccurViewImage([...occurViewImage, reader.result]);
        };
        reader.readAsDataURL(Image.target.files[0]);
      }
    }
    if (Image.target.id === "Death") {
      setDeathImage([...deathImage, Image.target.files[0]]);
      if (deathViewImage.length >= 10) {
        alert("이미지는 최대 10장까지 등록 가능합니다.");
      } else {
        const reader = new FileReader();
        reader.onload = () => {
          setDeathViewImage([...deathViewImage, reader.result]);
        };
        reader.readAsDataURL(Image.target.files[0]);
      }
    }
  };
  const ImageRemove = (e: any) => {
    occurViewImage.map((Image: any, idx: number) => {
      if (Image === e) {
        setOccurViewImage(
          occurViewImage.filter((v: any, i: number) => i !== idx)
        );
        setOccurImage(occurImage.filter((v: any, i: number) => i !== idx));
      }
    });
  };

  const ImageRemove2 = (e: any) => {
    deathViewImage.map((Image: any, idx: number) => {
      if (Image === e) {
        setDeathViewImage(
          deathViewImage.filter((v: any, i: number) => i !== idx)
        );
        setDeathImage(deathImage.filter((v: any, i: number) => i !== idx));
      }
    });
  };

  const InputHandler = (e: any) => {
    setDisease({
      ...disease,
      [e.target.name]: {
        diaryItemId: e.target.dataset.id,
        value: e.target.value,
      },
    });
  };

  const diseaseCount: diaryItemtype = inputitem.find(
    (v: diaryItemtype) => v.name === "diseaseCount"
  );

  const wormDeadWeight: diaryItemtype = inputitem.find(
    (v: diaryItemtype) => v.name === "wormDeadWeight"
  );

  return (
    <styles.WorkItemBox className={OpenWork === false ? "hide" : ""}>
      <styles.DiseaseItem>
        <div className="disease-top">
          <p className="disease-title">{diseaseCount.note}</p>
          <p className="disease-unit">{diseaseCount.unit}</p>
          <input
            type="text"
            name={diseaseCount.name}
            data-Id={diseaseCount.diaryItemId}
            onChange={InputHandler}
          />
        </div>
      </styles.DiseaseItem>
      <styles.ImageUpload>
        <p className="disease-img-title">발병사진</p>
        <label htmlFor="Occur">
          <div className="camera-btn">
            <p className="camera-img">
              <img src="./img/camera.svg" />
            </p>
            <p className="total-img">/10</p>
          </div>
        </label>
        <input
          type="file"
          id="Occur"
          accept="image/jpg, image/png, image/jpeg"
          onChange={(e: any) => DiseaseImageController(e)}
        />
        {occurViewImage.map((Image: any, idx: any) => {
          return (
            <styles.PreviewIamge>
              <p
                onClick={() => {
                  ImageRemove(Image);
                }}
              >
                <img src="./img/X.svg" />
              </p>
              <img src={Image} alt={idx} />
            </styles.PreviewIamge>
          );
        })}
      </styles.ImageUpload>

      <styles.DiseaseItem>
        <div className="disease-top">
          <p className="disease-title">{wormDeadWeight.note}</p>
          <p className="disease-unit">{wormDeadWeight.unit}</p>

          <input
            type="text"
            name={wormDeadWeight.name}
            data-Id={wormDeadWeight.diaryItemId}
            onChange={InputHandler}
          />
        </div>
      </styles.DiseaseItem>
      <styles.ImageUpload>
        <p className="disease-img-title">곤충폐사 샘플사진</p>
        <label htmlFor="Death">
          <div className="camera-btn">
            <p className="camera-img">
              <img src="./img/camera.svg" alt={"disease-img"} />
            </p>
            <p className="total-img">{deathViewImage.length}/10</p>
          </div>
        </label>
        <input
          type="file"
          id="Death"
          accept="image/jpg, image/png, image/jpeg"
          onChange={(e: any) => DiseaseImageController(e)}
        />
        {deathViewImage.map((Image: any, idx: any) => {
          return (
            <styles.PreviewIamge>
              <p
                onClick={() => {
                  ImageRemove2(Image);
                }}
              >
                <img src="./img/X.svg" alt={"deathViewImage"} />
              </p>
              <img src={Image} alt={idx} />
            </styles.PreviewIamge>
          );
        })}
      </styles.ImageUpload>
    </styles.WorkItemBox>
  );
};

export default { Growing, FeedChange, Cleaning, FeedGive, Disease };
